export default __webpack_public_path__ + "static/media/image.sipwaruna-cyber-school.a1f024e6.png";